import axios from 'axios';
import qs from 'qs';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  FE_USER_INFO,
  API_URL_MAIN,
  FE_URL
} from '@/config';
import { axios as Axios } from '@/lib/axiosUserInfo';
import storage from '@/utils/storage';
import { RESPONSE_ERR } from '@/constant';

export const handleLogout = () => {
  //clear all data save in localStorage
  storage.clearAll();

  // redirect
  // const encodedUrl = encodeURIComponent(FE_LOGOUT_URL);
  const url = '/login';
  window.location.href = url;
};

export const useLogin = () => {
  const navigate = useNavigate();

  //get current token
  // const token = storage.getToken()?.token;
  const token = JSON.parse(window.localStorage.getItem(`dpds_token`) || 'null')?.id_token

  //check code return from aws
  const queryParams = new URLSearchParams(window.location.search);
  const code = queryParams.get('code');

  useEffect(
    () => {
      // If there is no token and 'code' is present in the query parameters
      if (!token && code) {
        navigate('/')
      }
      // If there is no token and no 'code' query parameter, redirect to the login page
      else if (!token) {
        window.location.href = FE_URL;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return { token };
};

export const refreshToken = () => {
  const localRefreshToken = storage.getRefreshToken();

  if (!localRefreshToken) {
    handleLogout();
    return;
  }
  const refreshURL = `${API_URL_MAIN}/authorize/new_token`;
  const formData = {
    refresh_token: storage.getRefreshToken(),
  };
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };

  return axios
    .post(refreshURL, formData, config)
    .then((res) => {
      storage.setToken(res.data.access_token);
    })
    .catch((e) => {
      handleLogout();
    });
};

export const useGetUserInfo = () => {
  const [userInfoName, setUserInfoName] = useState<string>('');
  useEffect(() => {
    const getUserInfo = () => {
      return Axios.get(FE_USER_INFO);
    };

    getUserInfo()
      .then((res: any) => {
        setUserInfoName(res.name);
        storage.set(res.name, 'user_name');
        storage.set(res.email, 'mail_id');
      })
      .catch((e) => {
      });
  }, []);
  return { userInfoName };
};

export const checkLogin = () => {
  const userId = storage.getId();
  const token = storage.getToken();

  if (!userId || !token) {
    storage.clearAll();
    return false;
  } else {
    return true
  }
}

export const checkLegal = () => {
  const dpdsType = storage.getDpsdType();

  if (dpdsType == RESPONSE_ERR.E0104) {
    return false;
  } else if (dpdsType == RESPONSE_ERR.E0105) {
    return false;
  } else {
    return true;
  }
}

export const actionFromResetOrCreatePW = (type: any, navigate: any) => {
  if (type == RESPONSE_ERR.E0105) {
    navigate("/change-password");
  } else if (type == RESPONSE_ERR.E0104) {
    navigate("/create-password");
  }
}
